import { render, staticRenderFns } from "./AccommodationMain.vue?vue&type=template&id=1426f52c&"
import script from "./AccommodationMain.vue?vue&type=script&lang=js&"
export * from "./AccommodationMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1426f52c')) {
      api.createRecord('1426f52c', component.options)
    } else {
      api.reload('1426f52c', component.options)
    }
    module.hot.accept("./AccommodationMain.vue?vue&type=template&id=1426f52c&", function () {
      api.rerender('1426f52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/Accommodation/AccommodationMain.vue"
export default component.exports